module.exports = __webpack_public_path__ + "img/thumb-006-07.1ea01358.png";